// export const FEATURES_KEYS:any = {
//     CREATE_TENANT_10: {
//         name:"CREATE_TENANT_10",
//         value:10,
//         description:"Create maximum 10 tenant.",
//         displayName:"Create 10 tenant."
//     },
//     REPORT_EXCEL_EXPORT_BUTTON:{
//         name:"REPORT_EXCEL_EXPORT_BUTTON",
//         value:10,
//         description:"Export button for report page.",
//         displayName:"Export button for report page."
//     }
// }

export const FEATURES_KEYS:any= {
 "Pages.Client.ClientDocuments": {
    name: "Pages.Client.ClientDocuments",
    value: "Pages.Client.ClientDocuments",
    description: "Access to client documents page",
    displayName: "Client Documents"
  },

  "Pages.Invoices.Sacgst": {
    name: "Pages.Invoices.Sacgst",
    value: "Pages.Invoices.Sacgst",
    description: "Enable SAC/GST handling in invoices",
    displayName: "Invoice SAC/GST"
  },

  "Pages.PaymentSchedule.CalenderView": {
    name: "Pages.PaymentSchedule.CalenderView",
    value: "Pages.PaymentSchedule.CalenderView",
    description: "Calendar view for payment schedules",
    displayName: "Payment Calendar View"
  },

  "Pages.PaymentSchedule.PaymentTimelineAndForeCast": {
    name: "Pages.PaymentSchedule.PaymentTimelineAndForeCast",
    value: "Pages.PaymentSchedule.PaymentTimelineAndForeCast",
    description: "Payment timeline and forecast view",
    displayName: "Payment Timeline & Forecast"
  },

  "Pages.Reports.GenerateReport": {
    name: "Pages.Reports.GenerateReport",
    value: "Pages.Reports.GenerateReport",
    description: "Generate reports",
    displayName: "Generate Reports"
  }
};
